export enum TripTypes {
  DEPARTURE = 1,
  RETURN = 2
}
